import { useTrackLoggedIn } from "@intergamma/account"
import { isMobileApp } from "@intergamma/common/device"
import { useActiveVariant } from "@intergamma/experiments/hooks"
import { LoadingHeader } from "@intergamma/header"
import { Suspense } from "react"
import { Footer } from "./components/Footer"
import { ScrollToTop } from "./components/ScrollToTop"
import { formula } from "./config/formula"
import { useSessionDataQuery } from "./features/session-data/hooks/useSessionDataQuery"
import { SessionDataProvider } from "./features/session-data/SessionDataContext"
import { Header } from "./layouts/Header"
import { LoadingPageLayout } from "./layouts/LoadingPageLayout"
import { NewHeader } from "./layouts/NewHeader"
import { Routes } from "./Routes"

export function App() {
  const { data: sessionData } = useSessionDataQuery()
  const newHeader = useActiveVariant("abtest_dba_3399-dba_7") === "B-new"

  useTrackLoggedIn({
    formulaId: formula.id,
    customerId: sessionData?.uid,
    hashedId: sessionData?.hashedId,
  })

  return (
    <Suspense fallback={newHeader ? null : <LoadingHeader />}>
      <SessionDataProvider>
        {newHeader ? <NewHeader /> : <Header />}
        <Suspense fallback={<LoadingPageLayout />}>
          <ScrollToTop />
          <Routes />
        </Suspense>
        {!isMobileApp && (
          <Suspense fallback={null}>
            <Footer formula={formula} />
          </Suspense>
        )}
      </SessionDataProvider>
    </Suspense>
  )
}
